// extracted by mini-css-extract-plugin
module.exports = {"header":"Component-pepxpress_header__2MMZb","info":"Component-pepxpress_info__81hGw"};